export enum CoinMachineEnum {
  operationsDetail = 'CoinMachineDetail/OperationsDetail', // 取得兌幣機帳務清單
  operationsDetailV2 = 'v2/CoinMachineDetail/OperationsDetail', // 新系統：取得兌幣機帳務清單
  // goodsRecord = 'ClawMachineDetail/GoodsRecord', // 商品紀錄清單
  eventRecord = 'CoinMachineDetail/EventRecord', // 事件紀錄清單
  eventRecordV2 = 'v2/CoinMachineDetail/EventRecord' // 新系統：事件紀錄清單
}
